var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"phone-task-type-icon",attrs:{"src":_setup.iconSrc,"alt":"","width":"24","height":"24","data-testid":"phone-task-type-icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }